import React, { useCallback, useMemo, useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
} from 'reactstrap';

import { ORG_WEIGHT_SCHEME_OPTIONS } from './orgWeightsUtils';
import styles from './OrgWeights.module.scss';

function OrgWeightSchemePicker({ scheme, onSchemeChange, disabled = false }) {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = useMemo(
    () =>
      ORG_WEIGHT_SCHEME_OPTIONS.find((o) => o.value === scheme) ??
      ORG_WEIGHT_SCHEME_OPTIONS[0],
    [scheme]
  );

  const toggle = useCallback(() => {
    if (!disabled) {
      setIsOpen((open) => !open);
    }
  }, [disabled]);

  const selectScheme = useCallback(
    (value) => {
      setIsOpen(false);
      if (disabled || value === scheme) return;
      onSchemeChange(value);
    },
    [disabled, scheme, onSchemeChange]
  );

  return (
    <div className={styles['scheme-picker']}>
      <Label className={`mb-0 mr-2 ${styles['scheme-picker-label']}`}>
        Weight scheme
      </Label>
      <Dropdown
        isOpen={isOpen}
        toggle={toggle}
        className={styles['scheme-dropdown']}
      >
        <DropdownToggle caret size="sm" disabled={disabled} color="primary">
          {selectedOption.label}
        </DropdownToggle>
        <DropdownMenu className={styles['scheme-dropdown-menu']}>
          {ORG_WEIGHT_SCHEME_OPTIONS.map((opt) => (
            <DropdownItem
              key={opt.value}
              toggle={false}
              active={opt.value === scheme}
              onClick={() => selectScheme(opt.value)}
            >
              <div className={styles['scheme-dropdown-item']}>
                <span className={styles['scheme-dropdown-item-label']}>
                  {opt.label}
                </span>
                <span className={styles['scheme-dropdown-item-description']}>
                  {opt.tooltip}
                </span>
              </div>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default OrgWeightSchemePicker;
